import React from 'react';
import {
    Layout,
    Button,
    message,
    Space,
    Modal,
} from 'antd';
import { Link, withRouter } from 'react-router-dom';
import Footer from '../components/Footer';
import SNSBox from '../components/SNSBox';
import Unity, { UnityContent } from 'react-unity-webgl';
import {authorize, notifyAccessDemo, sendComment} from '../services/demoService';

import Logo from '../../resources/img/logo_w.png';
import { MessageOutlined } from '@ant-design/icons';


const { Header, Content } = Layout;



class MFDemo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchDemo: true,
            report: "",
        }

        this.unityContent= new UnityContent(
            process.env.PUBLIC_URL + "/game/Build/web_demo_v1.0.0.json",
            process.env.PUBLIC_URL + "/game/Build/UnityLoader.js",
            {
                modules: {
                    onAbort: () => {this.props.history.go(0)},
                }
            }
        );
    }

    componentDidMount() {
        notifyAccessDemo('mad-factory')
            .then(res => {})
        // const { code } = this.props.match.params;
        // const { history } = this.props;
        //
        // authorize(code)
        //     .then((res) => {
        //         if(res.data) {
        //
        //             this.setState({
        //                 fetchDemo: true,
        //                 demoCode: code
        //             });
        //         } else {
        //             Modal.error({
        //                 title: 'Please check your demo code',
        //                 style: {top: '200px'},
        //                 onOk() {
        //                     history.goBack();
        //                 }
        //             })
        //         }
        //     })
        //     .catch((err) => {
        //         Modal.error({
        //             title: 'Please check your demo code',
        //             style: {top: '200px'},
        //             onOk() {
        //                 history.goBack();
        //             }
        //         })
        //     })
    }

    componentWillUnmount() {
        this.setState({fetchDemo: false});
    }

    render() {
        const feedbackPath = "/feedback/mad-factory";
        return (
            <Layout className={'fadeIn full-layout demo'}>
                <Header className={'header home__header'}>
                    <Link className={'home__logo'} to={"/"}>
                        <img className={'home__logo__img'} src={Logo} alt="logo"/>
                        <p className={'home__logo__text'}>GAME</p>
                    </Link>
                </Header>
                <SNSBox/>
                <Content>
                    {   this.state.fetchDemo &&
                        <div>
                            <div className={'demo__error-box'}>
                                <p className={'demo__error-text'}>SCREEN TOO SMALL</p>
                            </div>
                            <div>
                                <div className={'demo__letter-box'}/>
                                <Unity tabIndex={'0'} className={"demo__game"} unityContent={this.unityContent}/>
                            </div>
                            <div className={'demo__letter-box--bottom'}/>

                            {/*<div className={'demo__comment'}>*/}
                                {/*<Space direction={"vertical"} className={'demo__comment__box'}>*/}
                                    {/*<Button icon={<MessageOutlined />} size={'large'} block type={'primary'} onClick={() => this.props.history.push(feedbackPath)}>Leave Feedback</Button>*/}
                                {/*</Space>*/}
                            {/*</div>*/}
                        </div>

                    }
                </Content>
                <Footer />
            </Layout>
        );
    }
}

export default withRouter(MFDemo);